export default {
	landing: {
		id: {
			top_adver_title: 'Mengundang teman-teman',
			special_money_name: 'Hasilkan',
			special_money_num: 'Rp10000',
			share_icon: 'Undang & Menghasilkan uang',
			top_adver_intro: 'Teman yang diundang akan<br> memberi Anda penghasilan<br> tambahan',
			id_item_title: 'Kode undangan',
			share_item_title: 'Membagikan',
			friends_item_title: 'Papan peringkat undangan teman',
			friend_list_memo: 'Pembaruan bulanan',
			invited: 'diundang',
		},
		wallive: {
			top_adver_title: 'Mengundang teman-teman',
			special_money_name: 'Hasilkan',
			special_money_num: 'Rp10000',
			share_icon: 'Undang & Menghasilkan uang',
			top_adver_intro: 'Teman yang diundang akan<br> memberi Anda penghasilan<br> tambahan',
			id_item_title: 'Kode undangan',
			share_item_title: 'Membagikan',
			friends_item_title: 'Papan peringkat undangan teman',
			friend_list_memo: 'Pembaruan bulanan',
			invited: 'diundang',
		},
		in: {
			top_adver_title: 'के लिए दोस्तों को आमंत्रित करें',
			special_money_name: 'कमाने',
			special_money_num: '1000 रुपये',
			share_icon: 'आमंत्रित करें और पैसा कमाएं',
			top_adver_intro: 'आमंत्रित मित्र आपको अतिरिक्त आय अर्जित करेंगे',
			id_item_title: 'आमंत्रण संकेत',
			share_item_title: 'साझा करना',
			friends_item_title: 'मित्र आमंत्रण लीडरबोर्ड',
			friend_list_memo: 'मासिक अपडेट',
			invited: 'आमंत्रण',
		},
		en: {
			top_adver_title: 'Invite friends to',
			special_money_name: 'earn',
			special_money_num: '＄1000',
			share_icon: 'Invite and Earn Money',
			top_adver_intro: 'Invited Friends Will Earn You Extra Income',
			id_item_title: 'Invitation Code',
			share_item_title: 'Share',
			friends_item_title: 'Friend Invitation Leaderboard',
			friend_list_memo: 'Monthly Updates',
			invited: 'invited',
		},
		ph: {
			top_adver_title: 'Anyayahan ang mga kaibigan na',
			special_money_name: 'kumita ng',
			special_money_num: '₱ 1000',
			share_icon: 'Mag-anyaya & Gumawa ng pera',
			top_adver_intro: 'Ang mga inimbitahang kaibigan<br> ay kikita ka ng<br> sobrang kita',
			id_item_title: 'Code ng paanyaya',
			share_item_title: 'Magbahagi',
			friends_item_title: 'Leaderboard ng imbitasyon ng mga kaibigan',
			friend_list_memo: 'Buwanang pag-update',
			invited: 'inanyayahan',
		},
		
	},
	shareMsg: {
		id: {
			share_title: '💰VidMate dapat menghasilkan uang dengan mudah❗️',
			share_description: '💲VidMate adalah aplikasi hebat🌹, Anda dapat dengan mudah menghasilkan uang di sini💰! Anda juga bisa mencobanya!😊',
			share_img: 'https://www.vidfree.net/h5/img/invite_whatsapp_300_id.png',
		},
		wallive: {
			share_title: '💰Wallive dapat menghasilkan uang dengan mudah❗️',
			share_description: '💲Wallive adalah aplikasi hebat🌹, Anda dapat dengan mudah menghasilkan uang di sini💰! Anda juga bisa mencobanya!😊',
			share_img: 'https://www.wallive.site/img/invite_whatsapp.png',
		},
		in: {
			share_title: '💰VidMate आसानी से पैसा कमा सकता है❗️',
			share_description: '💲VidMate एक बेहतरीन ऐप है🌹, आप यहां आसानी से पैसा कमा सकते हैं💰! आपको कोशिश करने की सलाह देते हैं!😊',
			share_img: 'https://www.vidfree.net/h5/img/invite_whatsapp_300_in.png',
		},
		en: {
			share_title: '💰VidMate can Make Money easily❗️',
			share_description: '💲VidMate is an amazing app🌹, You can easily make money here💰! Recommend you to try!😊',
			share_img: 'https://www.vidfree.net/h5/img/invite_whatsapp_300_en.png',
		},
		ph: {
			share_title: '💰VidMate can Make Money easily❗️',
			share_description: '💲VidMate is an amazing app🌹, You can easily make money here💰! Recommend you to try!😊',
			share_img: 'https://www.vidfree.net/h5/img/invite_whatsapp_300_ph.png',
		},
	},
	sharePage: {
		id: {
			top_adver_title: 'Unduh VidMate untuk mendapatkan',
			special_money_num: 'RP10000',
			special_money_name: 'setiap hari',
			id_item_title: 'Kode undangan',
			invite_item_title: 'Langkah-langkah undangan',
      step: 'Langkah',
      step1: 'Install',
      step2: 'Masukkan kode undangan',
      step3: 'Menghasilkan uang',
      download_btn: 'Unduh',

			copy: 'Salin',
			
			auto_msg: 'VidMate akan mengunduh secara otomatis setelah 3 detik, apakah Anda ingin membatalkan?',
		},
		wallive: {
			top_adver_title: 'Unduh Wallive untuk mendapatkan',
			special_money_num: 'RP10000',
			special_money_name: 'setiap hari',
			id_item_title: 'Kode undangan',
			invite_item_title: 'Langkah-langkah undangan',
      step: 'Langkah',
      step1: 'Install',
      step2: 'Masukkan kode undangan',
      step3: 'Menghasilkan uang',
      download_btn: 'Unduh',

			copy: 'Salin',
			
			auto_msg: 'Wallive akan mengunduh secara otomatis setelah 3 detik, apakah Anda ingin membatalkan?',
		},
		in: {
			top_adver_title: 'कमाने के लिए VidMate डाउनलोड करें',
			special_money_num: '1000 रुपये',
			special_money_name: 'रोजाना',
			id_item_title: 'आमंत्रण संकेत',
			invite_item_title: 'आमंत्रण चरण',
      step: 'चरण',
      step1: 'स्थापित करें',
      step2: 'आमंत्रण कोड दर्ज करें',
      step3: 'पैसा बनाएं',
      download_btn: 'डाउनलोड',

			copy: 'प्रतिलिपि',
			
			auto_msg: '3 सेकंड के बाद VidMate अपने आप डाउनलोड हो जाएगा, क्या आप रद्द करना चाहते हैं?',
		},
		en: {
			top_adver_title: 'Download VidMate to earn ',
			special_money_num: '＄1000',
			special_money_name: 'daily',
			id_item_title: 'Invitation Code',
			invite_item_title: 'Invitation Steps',
      step: 'Step',
      step1: 'Install',
      step2: 'Input your Invitation Code',
      step3: 'Make Money',
      download_btn: 'Download',

			copy: 'Copy',
			
			auto_msg: 'VidMate will automatically download after 3 seconds, do you want to cancel?',
		},
		ph: {
			top_adver_title: 'Mag-download ng VidMate at makakuha ng',
			special_money_num: '₱ 1000',
			special_money_name: 'araw-araw',
			id_item_title: 'Code ng paanyaya',
			invite_item_title: 'Mga hakbang sa paanyaya',
      step: 'Hakbang',
      step1: 'I-Install',
      step2: 'Input Code ng paanyaya',
      step3: 'Gumawa ng pera',
      download_btn: 'I-download',

			copy: 'Kopya',

			auto_msg: 'Awtomatikong i-download ang VidMate pagkatapos ng 3 segundo, nais mo bang kanselahin',
		},
	},
}
